import { render, staticRenderFns } from "./IcnMenu.vue?vue&type=template&id=0ba5cce0"
import script from "./IcnMenu.vue?vue&type=script&lang=js"
export * from "./IcnMenu.vue?vue&type=script&lang=js"
import style0 from "./IcnMenu.vue?vue&type=style&index=0&id=0ba5cce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports